var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "Renewal" },
    [
      _c("div", { staticClass: "topbar" }, [
        _c("i", { on: { click: _vm.goHome } }),
        _vm._v(" "),
        _c("div", { staticClass: "userInfo" }, [
          _c(
            "div",
            {
              staticClass: "changeLangBtn",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  _vm.moreLang()
                }
              }
            },
            [
              _vm._v("\n        " + _vm._s(_vm.$t("language")) + "\n        "),
              _c("em", { staticClass: "iconfont icon-een" }),
              _vm._v(" "),
              _c(
                "ul",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.changeLangBox,
                      expression: "changeLangBox"
                    }
                  ],
                  staticClass: "chooseLangUl"
                },
                _vm._l(_vm.langList, function(item, index) {
                  return _c(
                    "li",
                    {
                      key: index,
                      staticClass: "chooseLangUlli",
                      on: {
                        click: function($event) {
                          _vm.setLanguage(item.id)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n            " + _vm._s(item.name) + "\n          "
                      )
                    ]
                  )
                })
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "settingBtn",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  _vm.setting()
                }
              }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.name ? _vm.name : _vm.names) +
                  "\n        "
              ),
              _c("em", { staticClass: "iconfont icon-een" }),
              _vm._v(" "),
              _c(
                "ul",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.settingBoxVis,
                      expression: "settingBoxVis"
                    }
                  ],
                  staticClass: "chooseLangUl chooseLangUls"
                },
                [
                  _c("li", { on: { click: _vm.toMyAccount } }, [
                    _vm._v(_vm._s(_vm.$t("myHome")))
                  ]),
                  _vm._v(" "),
                  _c("li", { on: { click: _vm.race } }, [
                    _vm._v(_vm._s(_vm.$t("myPageTitle")))
                  ]),
                  _vm._v(" "),
                  _c("li", { on: { click: _vm.logOut } }, [
                    _vm._v(_vm._s(_vm.$t("setting_2")))
                  ])
                ]
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "mainBox",
          attrs: { id: "mainBox" },
          on: { click: _vm.clickBox }
        },
        [
          _c("div", { staticClass: "signInBox" }, [
            _c("div", { staticClass: "forgetPsd1" }, [
              _vm._v(_vm._s(_vm.$t("pay_txt1")))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "explanation" }, [
              _vm.switchType == "0"
                ? _c("div", { staticClass: "title" }, [
                    _vm._v(
                      "\n          " + _vm._s(_vm.$t("pay_txt2")) + "\n        "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.switchType == "1"
                ? _c("div", { staticClass: "title" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("pay_txt2_1")) +
                        "\n        "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "explanationMsgs" }, [
                _vm.switchType == "0"
                  ? _c("div", {
                      staticClass: "btext",
                      domProps: { innerHTML: _vm._s(_vm.$t("langTitle")) }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.switchType == "0"
                  ? _c("div", {
                      staticClass: "text",
                      domProps: { innerHTML: _vm._s(_vm.$t("langTitle_1")) }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.switchType == "1"
                  ? _c("div", {
                      staticClass: "btext",
                      domProps: { innerHTML: _vm._s(_vm.$t("langTitle2")) }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.switchType == "1"
                  ? _c("div", {
                      staticClass: "text",
                      domProps: { innerHTML: _vm._s(_vm.$t("langTitle2_1")) }
                    })
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "space" }),
            _vm._v(" "),
            _c("div", { staticClass: "pay" }, [
              _vm.$i18n.locale != "he"
                ? _c(
                    "section",
                    {
                      staticClass: "pay-box",
                      class: { active: _vm.switchMode == "0" },
                      on: {
                        click: function($event) {
                          _vm.switchModeHandle("0")
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "pic" }, [
                        _c("img", {
                          attrs: { src: _vm.img2Url, width: "100%" }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "msg" }, [
                        _c("span", { staticClass: "bg" }, [
                          _vm._v(_vm._s(_vm.$t("pay_text10_1")))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "bg" }, [
                          _vm._v(_vm._s(_vm.$t("pay_text10_2")))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "sm" }, [
                          _vm._v(_vm._s(_vm.$t("pay_text10_3")))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "sm" }, [
                          _vm._v(_vm._s(_vm.$t("pay_text10_4")))
                        ])
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$i18n.locale != "he"
                ? _c(
                    "section",
                    {
                      staticClass: "pay-box",
                      class: { active: _vm.switchMode == "1" },
                      on: {
                        click: function($event) {
                          _vm.switchModeHandle("1")
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "msg" }, [
                        _c("span", { staticClass: "bg" }, [
                          _vm._v(_vm._s(_vm.$t("pay_text4_0")))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "bg" }, [
                          _vm._v(_vm._s(_vm.$t("pay_text4_1")))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "sm" }, [
                          _vm._v(_vm._s(_vm.$t("pay_text4_2")))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "sm" }, [
                          _vm._v(_vm._s(_vm.$t("pay_text4_3")))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "sm" }, [
                          _vm._v(_vm._s(_vm.$t("pay_text4_4")))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "pic" }, [
                        _c("img", {
                          attrs: {
                            src: _vm.img2Url,
                            width: "150px",
                            height: "150px"
                          }
                        })
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "useCodeBtn",
                  on: {
                    click: function($event) {
                      _vm.usingCode = true
                    }
                  }
                },
                [_c("b", [_vm._v(_vm._s(_vm.$t("redeemCode_useBtn")))])]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.usingCode,
                      expression: "usingCode"
                    }
                  ],
                  staticClass: "bgiOver"
                },
                [
                  _c("div", { staticClass: "codeUse" }, [
                    _c("div", {
                      staticClass: "codeUse-closeBtn",
                      on: {
                        click: function($event) {
                          ;(_vm.usingCode = false), _vm.closeCodeUsing()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "codeUse-title" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("redeemCode_dialog_title")))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "codeUse-input" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.codeUsingInput,
                            expression: "codeUsingInput"
                          }
                        ],
                        attrs: {
                          placeholder: _vm.$t("redeemCode_dialog_input_hint")
                        },
                        domProps: { value: _vm.codeUsingInput },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.codeUsingInput = $event.target.value
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "codeUse-info" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("redeemCode_dialog_info")))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "codeUse-confirmBtn" }, [
                      _c(
                        "span",
                        {
                          on: {
                            click: function($event) {
                              _vm.submitCode(_vm.codeUsingInput)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("redeemCode_usingBtn")) +
                              "\n              "
                          )
                        ]
                      )
                    ])
                  ])
                ]
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.chatShow,
              expression: "chatShow"
            }
          ],
          staticClass: "bgiOvers"
        },
        [
          _c("div", { staticClass: "over over1" }, [
            _c("div", { staticClass: "timeout03" }, [
              _vm._v(_vm._s(_vm.time) + "s后自动进入首页")
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "timeout04",
              on: {
                click: function($event) {
                  _vm.goHome()
                }
              }
            })
          ])
        ]
      ),
      _vm._v(" "),
      _c("LeapPopup", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.maskBox,
            expression: "maskBox"
          }
        ],
        attrs: {
          title: _vm.$t("timeout01"),
          content: _vm.$t("timeout02"),
          cancelButtonTxt: _vm.$t("timeout04"),
          okButtonTxt: _vm.$t("timeout03"),
          isConfirm: false
        },
        on: { onOK: _vm.logOut }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-50055b94", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50055b94","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wechat.vue
// module id = null
// module chunks = 